import { render } from "./PriorityCodes.vue?vue&type=template&id=388cacd9&scoped=true"
import script from "./PriorityCodes.vue?vue&type=script&lang=js"
export * from "./PriorityCodes.vue?vue&type=script&lang=js"

import "./PriorityCodes.vue?vue&type=style&index=0&id=388cacd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388cacd9"]])

export default __exports__